/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UnarchiveUserInput = {
    userId: string;
    clientMutationId?: string | null | undefined;
};
export type unarchiveUserMutationVariables = {
    input: UnarchiveUserInput;
};
export type unarchiveUserMutationResponse = {
    readonly unarchiveUser: {
        readonly clientMutationId: string | null;
        readonly user: {
            readonly __typename: string;
            readonly archived: boolean | null;
        };
    } | null;
};
export type unarchiveUserMutation = {
    readonly response: unarchiveUserMutationResponse;
    readonly variables: unarchiveUserMutationVariables;
};



/*
mutation unarchiveUserMutation(
  $input: UnarchiveUserInput!
) {
  unarchiveUser(input: $input) {
    clientMutationId
    user {
      __typename
      archived
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unarchiveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnarchiveUserPayload",
        "kind": "LinkedField",
        "name": "unarchiveUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unarchiveUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnarchiveUserPayload",
        "kind": "LinkedField",
        "name": "unarchiveUser",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aff3c4525dadcf3d5a3feeab28cbcea4",
    "id": null,
    "metadata": {},
    "name": "unarchiveUserMutation",
    "operationKind": "mutation",
    "text": "mutation unarchiveUserMutation(\n  $input: UnarchiveUserInput!\n) {\n  unarchiveUser(input: $input) {\n    clientMutationId\n    user {\n      __typename\n      archived\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'dbc3526b97cfd87f6c37d0d586bafc8e';
export default node;
